/**
 * Walkthrough Hook
 *
 * Provides access to the walkthrough context for starting/stopping tours.
 */

import { useContext } from 'react';
import { WalkthroughContext } from '../WalkthroughProvider';

/**
 * Hook to access walkthrough functionality
 *
 * Must be used within a WalkthroughProvider.
 *
 * @returns Walkthrough context with tour control functions
 * @throws Error if used outside WalkthroughProvider
 *
 * @example
 * ```tsx
 * function MyComponent() {
 *   const { startTour, isActive } = useWalkthrough();
 *
 *   return (
 *     <Button onClick={() => startTour('ddSettingsTour')}>
 *       Start Rondleiding
 *     </Button>
 *   );
 * }
 * ```
 */
export function useWalkthrough() {
  const context = useContext(WalkthroughContext);

  if (!context) {
    throw new Error('useWalkthrough must be used within WalkthroughProvider');
  }

  return context;
}
